import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

import "./i18n";
import "./css/raisenow.scss";
import Calculators from "./components/calculators";
import MyclimateSubscription from "./components/myclimate_subscription";
import PartnerContext from "./partner_context";
import Quiz from "./components/Quiz";
import setupI18n from "./i18n";
import quizQuestions from "./QuizQuestions";

if (process.env.NODE_ENV !== "production") {
  console.log("myclimate calculators loaded 🌍");
}

const Container = styled.div`
  max-width: 620px;
`;

const ModeView = ({ mode, config }) => {
  switch (mode) {
    case "subscription":
      return <MyclimateSubscription config={config} />;
    case "quiz":
      return (
        <Quiz isTest={config.test} questions={quizQuestions(config.language)} />
      );
    default:
      return <Calculators />;
  }
};

const Root = ({ config }) => {
  let url = new URL(window.location.href);

  config.language = url.searchParams.get("language") || config.language || "en";
  config.currency =
    url.searchParams.get("currency") || config.currency || "EUR";
  config.tonPrices ||= {};

  setupI18n(config.language);

  return (
    <PartnerContext.Provider value={config}>
      <Container>
        <ModeView mode={config.mode} config={config} />
      </Container>
    </PartnerContext.Provider>
  );
};

export default {
  embed: (config) => {
    ReactDOM.render(
      <Root config={config} />,
      document.getElementById(config.container)
    );
  },
};
